export default `float i,g,e,s=3.,l;
    vec3 q=p;
    for(int j=0;j++<9;)
      p=mod(p-1.,2.)-1.,
      l=1.2/pow(pow(dot(pow(abs(p),vec3(5.0)),vec3(1.0)),.2),1.6),
      p*=l, s*=l;
    return abs(p.y)/s;
  }`